<div
  class="ui-date-picker"
  [class.ui-date-picker--small]="size() === 'small'"
  [class.ui-date-picker--error]="!!displayedError()"
  [class.ui-date-picker--disabled]="disabled()"
  [class.ui-date-picker--focused]="focused()"
>
  @if (label()) {
    <label class="ui-date-picker__label" [for]="id()">
      {{ label() }}
      @if (required()) {
        <span class="ui-date-picker__label-required">*</span>
      }
    </label>
  }

  <div class="ui-date-picker__main" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <input
      #inputEl
      [id]="id()"
      class="ui-date-picker__input"
      type="text"
      autocomplete="off"
      spellcheck="false"
      [value]="display()"
      [attr.placeholder]="placeholderText()"
      [disabled]="disabled()"
      [readOnly]="!canUseInput()"
      [attr.aria-invalid]="!!displayedError()"
      (beforeinput)="onBeforeInput($event)"
      (input)="onInput()"
      (compositionstart)="onCompositionStart()"
      (compositionend)="onCompositionEnd()"
      (keydown)="onKeyDown($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (click)="onClick()"
    />

    @if (!isEmpty() && !disabled()) {
      <button
        uiFieldAction="danger"
        class="ui-date-picker__action"
        aria-label="Clear"
        (click)="clear()"
      >
        <fr8bot-ui-icon name="x-1-12" [size]="12" />
      </button>
    }

    <button
      uiFieldAction
      class="ui-date-picker__action"
      aria-label="Open calendar"
      [disabled]="!canUsePanel()"
      (click)="togglePanel()"
    >
      <fr8bot-ui-icon [name]="compiledPattern().hasDate ? 'calendar-16' : 'clock-16'" [size]="16" />
    </button>
  </div>

  @if (isErrorVisible()) {
    <div class="empty-hidden">
      <fr8bot-ui-validation-error [error]="displayedError()" />
    </div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPanelClass]="'ui-date-picker-panel'"
  (overlayOutsideClick)="closePanel()"
  (detach)="closePanel()"
>
  <div class="ui-date-picker__panel">
    @if (compiledPattern().hasDate) {
      <mat-calendar
        [selected]="calendarValue()"
        [startAt]="startAt()"
        [minDate]="minDateValue()"
        [maxDate]="maxDateValue()"
        [headerComponent]="calendarHeader"
        (selectedChange)="onCalendarSelect($event)"
      />
    }

    @if (compiledPattern().hasDate && compiledPattern().hasTime) {
      <div class="ui-date-picker__panel-divider"></div>
    }

    @if (compiledPattern().hasTime) {
      <fr8bot-ui-date-picker-time-list
        [hour24]="selectedHour()"
        [minute]="selectedMinute()"
        [hour12Format]="compiledPattern().hour12"
        [hourStep]="hourStep()"
        [minuteStep]="minuteStep()"
        [disabled]="!canUsePanel()"
        (timeChange)="onTimeSelect($event)"
      />
    }
  </div>
</ng-template>
